import { createSelector } from 'reselect';
import get from 'lodash/get';
import { aboutContentReducerKey } from './AboutContentConstants';

export function aboutContent(state) {
  return state.get(aboutContentReducerKey);
}

export function isLoading(state) {
  return aboutContent(state).get('isLoading');
}

function databases(state) {
  return aboutContent(state).get('databases');
}

export const preparedDatabases = createSelector([databases], (databasesData) => {
  if (!databasesData) {
    return [];
  }
  return Object.values(databasesData).sort((a, b) => get(a, 'priorities.ABOUT_CONTENT_PAGE') - get(b, 'priorities.ABOUT_CONTENT_PAGE'));
});

function updateInfo(state) {
  return aboutContent(state).get('updateInfo');
}

const infoItems = {
  substances: {
    name: 'substances',
  },
  reactions: {
    name: 'reactions',
  },
  dpitems: {
    name: 'bioactivity datapoints',
  },
  tgitems: {
    name: 'targets',
  },
  citations: {
    name: 'documents',
  },
  patents: {
    name: 'patents',
  },
};

export const preparedUpdateInfo = createSelector([updateInfo], (info) => {
  if (!info) {
    return [];
  }

  return Object.keys(infoItems)
    .map((item) => {
      const { name } = infoItems[item];
      const value = get(info[item], 'entriesCountIncrement', null);
      if (!value) {
        return null;
      }
      return {
        name,
        value,
      };
    })
    .filter((item) => !!item);
});

export function BEBuildNumber(state) {
  return aboutContent(state).get('BEBuildNumber');
}
